import { api, API } from "@/lib/api";
import { authHeader } from "@/lib/aadhaar";

export const LIVE_PATH = "/simran-live";
export const KINDS = ["intro", "explain", "check", "explain", "check", "explain", "check", "summary"];
const SID = "rs_simran_live_session";
export const liveSession = () => {
  let s = localStorage.getItem(SID);
  if (!s) { s = `${Date.now()}${Math.random().toString(16).slice(2)}`; localStorage.setItem(SID, s); }
  return s;
};

const A = () => authHeader("student");
export const liveApi = {
  topics: () => api.get("/simran-live/topics", A()).then((r) => r.data.topics),
  start: (topic, lang) => api.post("/simran-live/start", { topic, lang, session_id: liveSession() }, A()).then((r) => r.data),
  status: (id) => api.get(`/simran-live/${id}`, A()).then((r) => r.data),
  section: (id, n, have = 0) => api.get(`/simran-live/${id}/section/${n}`, { ...A(), params: { have }, timeout: 150000 }).then((r) => r.data),
  pick: (id, n, pick) => api.post(`/simran-live/${id}/check/${n}`, { pick }, A()).then((r) => r.data),
  end: (id) => api.post(`/simran-live/${id}/end`).catch(() => null),
  beaconEnd: (id) => navigator.sendBeacon?.(`${API}/simran-live/${id}/end`),
  tts: (text, lang) => api.post("/simran-live/tts", { text, lang }, A()).then((r) => r.data),
};

// Streams Simran's answer to a Pause & Ask question; calls onText with the growing text.
export async function askLive(id, question, section, onText) {
  const res = await fetch(`${API}/simran-live/${id}/ask`, { method: "POST", headers: { "Content-Type": "application/json", ...A().headers }, body: JSON.stringify({ question, section }) });
  if (res.status === 429) throw new Error("busy");
  if (!res.ok || !res.body) throw new Error("failed");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "", text = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const events = buf.split("\n\n");
    buf = events.pop();
    for (const ev of events) {
      const line = ev.trim();
      if (!line.startsWith("data:")) continue;
      const d = JSON.parse(line.slice(5));
      if (d.error) throw new Error("failed");
      if (d.t) { text += d.t; onText(text); }
    }
  }
  return text.trim();
}

export const errMsg = (e, fallback) => e?.response?.data?.detail || fallback;
